import type { AppBranding } from '@/constants/chat';

/** Xiaocai's existing palette is light-only; retain its accent in both appearances. */
export const hostThemeBranding = (branding: Partial<AppBranding> = {}) => ({
  logo: branding.logo,
  colors: { primary: branding.colors?.primary ?? branding.colors?.accent },
  appearances: { light: { colors: branding.colors, themeTokens: branding.themeTokens } },
});
